import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

type ListFiltersActionsProps = {
  hasChanges: boolean;
  isClearable: boolean;
  onAllFiltersClear: () => void;
  onApplyFilters: () => void;
};

export const ListFiltersActions = (props: ListFiltersActionsProps) => {
  const { hasChanges, isClearable, onAllFiltersClear, onApplyFilters } = props;
  const { t } = useTranslation();

  return (
    <div className="mt-3 flex flex-wrap items-center justify-end gap-2">
      {hasChanges && (
        <p className="text-muted-foreground mr-auto text-xs font-medium">
          {t('Filters have been changed but not applied')}
        </p>
      )}
      {isClearable && (
        <Button
          type="button"
          variant="ghost"
          onClick={onAllFiltersClear}
        >
          {t('Clear all')}
        </Button>
      )}
      <Button
        type="button"
        onClick={onApplyFilters}
        variant={hasChanges ? 'default' : 'outline'}
        className="min-w-30"
      >
        {t('Filter')}
      </Button>
    </div>
  );
};
